<template>
    <section class="pdtb3">
        <div class="container video-player pr-player-canvas" v-if="sources" :class="[{ playing: is_playing, transition: in_transition }]">

            <div class="video-player-overlay intro" v-if="!is_lib_vid">
                <span>When you're ready...</span>
                <div @click="togglePlay()"></div>
                <span class="mt100"><small>Note: you can change your selected warmup routine in <a href="/account/settings">your account settings</a>.</small></span>
            </div>
            <div class="video-player-overlay intro" v-if="is_lib_vid">
                <h1>{{ is_lib_vid.video_data.title }}</h1>
                <span>Click below when you're ready.</span>
                <div @click="togglePlay()"></div>
                <span v-if="is_lib_vid.video_data.props.length" class="small mt300 mb200">You'll need the following before you start:</span>
                <ul class="prop-list" v-if="is_lib_vid.video_data.props.length">
                    <li v-for="prop in is_lib_vid.video_data.props" class="prop-label invert" :class="prop"></li>
                </ul>
            </div>

            <div class="video-player-overlay outro" v-if="!is_lib_vid">

                <small class="ping-state drill" :class="ping_state"></small>

                <small v-if="insufficient_watch_time">Sorry, not enough watch time was logged to record a completion!</small>

                <small v-if="ping_state === 'error'" class="ping-error ping-status">Please check your connection and <span @click="pingSequenceCompleted(is_lib_vid)">click here to retry</span></small>

                <small><a href="#" @click.prevent="togglePlay()">Click here to repeat these moves</a></small>
                <small>Finding this too easy? <a href="/builder">Level up now!</a> <br>Alternatively: Add custom-made routines from <a href="/workout-library">the library</a> into your
                    <a href="/calendar">calendar</a>.</small>
            </div>

            <div class="video-player-overlay outro" v-if="is_lib_vid">

                <small class="ping-state lib" :class="ping_state"></small>

                <small v-if="insufficient_watch_time">Sorry, not enough watch time was logged to record a completion!</small>

                <small v-if="ping_state === 'error'" class="ping-error ping-status">Please check your connection and <span @click="pingSequenceCompleted(is_lib_vid)">click here to retry</span></small>

                <small><a href="#" @click.prevent="togglePlay()">Click here to repeat this workout</a></small>
                <small>Remember, you can <a href="/private-library">customise your private library</a> and
                    <a href="/calendar">build your own monthly schedule</a> at any time.</small>
            </div>

            <div class="video-player-overlay autoplay-error">
                <small><i class="fa fa-exclamation-triangle"></i> Error playing next video. Your browser might not support video autoplay.
                    <br>Click the button below to attempt manual playback.</small>
                <div @click="recoverAndPlay()"></div>
            </div>

            <div class="player-head">
                <span>{{ title_text }}</span>
            </div>

            <span id="skip-start-btn" class="main-player" :class="{show: show_skip_start_btn, initialized: skip_start_btn_initialized}" @click="skipTo"><span>skip intro</span></span>

<vue-plyr ref="plyr" :options="playerOptions">
    <video></video>
</vue-plyr>

            <div class="iwd-player-controls">
                <button :class="{ disabled: (current_drill_index === 0) }" @click="playPrevious()"></button>
                <button :class="[{ disabled: false, play: !is_playing, pause: is_playing }]" @click="togglePlay()"></button>
                <button :class="{ disabled: (current_drill_index === (sources.length - 1)) }" @click="playNext()"></button>
            </div>

        </div>
    </section>
</template>

<script>

    var emitter = require('tiny-emitter/instance');
    import Hls from 'hls.js';
    import postToUrl from '../mixins/postToUrl';

    export default {
    	data(){
    		return {
                playerOptions: {
                    controls: [
                    	'play-large',
	                    'progress',
	                    'volume',
                        'play',
                        'fullscreen',
                        'settings'
                    ],
                    settings: [
                    	'quality'
                    ]
                },
                is_playing: false,
                is_seeking: false,
                in_transition: false,
                ping_state: 'ready',
                current_drill_index: 0,
                is_lib_vid: false,
                next_day: null,
                sources: null,
                hls: null,
                autoplay_error: false,
                start_time: false,
                insufficient_watch_time: false,
                show_skip_start_btn: false,
                skip_start_btn_initialized: false
            }
        },
        computed: {
            player () {
                return this.$refs.plyr.player
            },
            title_text(){
                if(this.in_transition || this.is_seeking || !this.sources) return 'Loading...';

                const vid_title = this.sources[this.current_drill_index].title;

                if(this.is_lib_vid)
                {
                	return this.is_playing ? 'Now playing (from the library): ' + vid_title : 'Ready';
                }

                if(this.is_playing && this.current_drill_index === 0)
                {
                    return vid_title;
                }

                return this.is_playing ? 'Now playing ('+(this.current_drill_index)+'/5): '+ vid_title : 'Ready';
            }
        },
        mounted(){

    		if (!Hls.isSupported()){
    			alert('Sorry, your browser does not support HLS video streaming');

          this.autoHlsErrorRecovery();

    			throw new Error('HLS not supported.');
            }

    		emitter.on('calendarModalOpening', () => {
    			this.player.pause();
            });

            const time_now = Date().toString();

            this.getFirstOfSequenceData(time_now).then((response)=>{

            	this.sources = response.data.sources;

            	if(!this.sources){
            		alert('No sequence found. Please make sure you have at least one chapter selected!');
            		window.location.href = '/builder';
            		return false;
                }

            	if(response.data.is_lib_vid)
                {
                	this.is_lib_vid = response.data.is_lib_vid;
                	this.skip_start = response.data.skip_start;

                }else{

		            this.getRestOfSequenceData(time_now).then((response)=>{
			            for(let i=0; i<response.data.sources.length; i++){
				            this.sources.push(response.data.sources[i]);
			            }
		            });

                }

            	this.$nextTick(()=>{

                    this.mountAndAttach();

            		setTimeout(()=>{
            			this.hideLoader();
                    },250);

		            emitter.on('windowResized', ()=>{
                        this.allowHeightAdjust();
                    });
		            this.bindPlayerFuncs();
                });
            });
        },
        methods: {
        autoHlsErrorRecovery()
        {
            if(confirm("'HLS' video is a modern adaptive video-streaming protocol, which The Hub uses by default. However, your browser appears to be struggling to play video in this format.\n\nWould you like to switch to the standard video player, which may fix any issues you are currently experiencing?\n\n(Your settings will be updated and the page will reload).")){

              // post request to update user settings...
              const res = this.postToUrl('/account/force-non-hls');

              return false;
            }
        },
    		bindPlayerFuncs()
            {
                this.player.on('playing',()=>{
                    setTimeout(()=>{
                    	this.fixHeight();
                    },200);
                    this.is_playing = true;
                    this.autoplay_error = false;
                    this.in_transition = false;
                    this.is_seeking = false;
                    $('.video-player-overlay').fadeOut(1000);

                	this.skip_start_btn_initialized = true;
                    this.checkSkipStartVisibility();
                });
                this.player.on('pause',()=>{
                    this.is_playing = false;
                });
                this.player.on('seeking', ()=>{
                    this.is_seeking = true;
                });
                this.player.on('ended', ()=>{

                    this.in_transition = true;
                    this.is_playing = false;

                    if(this.current_drill_index === (this.sources.length - 1)){ // last video; sequence complete

                        if(this.player.fullscreen.active){
                            this.player.fullscreen.exit();
                        }

                        this.current_drill_index = 0;

                        this.mountAndAttach();

                        $('.video-player-overlay.outro').css('display', 'flex').hide().fadeIn(1000);

                        const time_now = Math.round(Date.now() / 1000);

                        const watch_time = time_now - this.start_time;

                        let required_watch_time = this.is_lib_vid ? this.is_lib_vid.video_data.duration / 3 : 180;

                        if(process.env.NODE_ENV === 'development')
                        {
                            required_watch_time = 1;
                        }

                        if(watch_time < required_watch_time)
                        {
                            this.insufficient_watch_time = true;
                        }else{
                        	this.insufficient_watch_time = false;
                            this.pingSequenceCompleted(this.is_lib_vid, watch_time);
                        }

                        return;
                    }
                    this.current_drill_index++;
                    this.mountAndAttach();
                    this.play();
                });
            },
            checkSkipStartVisibility()
            {
                if(this.skip_start && (this.player.currentTime < this.skip_start))
                {
                    this.show_skip_start_btn = true;
                    this.runCycleToRemoveSkipStartBtn();
                }else {
                    this.show_skip_start_btn = false;
                }
            },
            runCycleToRemoveSkipStartBtn()
            {
                clearTimeout(this.run);
                this.run = setTimeout(()=>{

                    if(!this.player.playing)
                        return false;

                    if(this.player.currentTime >= this.skip_start){
                        this.show_skip_start_btn = false;
                        return false;
                    }
                    this.runCycleToRemoveSkipStartBtn();
                },1000);
            },
            skipTo()
            {
                this.player.currentTime = this.skip_start;
            },
            mountAndAttach(){
                if(this.hls){
                    this.hls.destroy();
                }
                this.hls = new Hls();
                this.checkErrors();
                this.hls.loadSource(this.sources[this.current_drill_index].source);
                this.hls.attachMedia(this.player.media);
            },
            checkErrors()
            {
                if(
                    typeof this.current_drill_index === 'undefined' ||
                    typeof this.sources[this.current_drill_index] === 'undefined' ||
                    typeof this.sources[this.current_drill_index].source === 'undefined'
                )
                {
                	console.log('Error. Undefined value detected. Logging to server...');

                    const log_props = {
                        drill_index: this.current_drill_index,
                        sources: this.sources
                    };

                    axios.post('/api/log_player_error', {log_props: log_props}).then((response)=>{

                    }).catch((e) => {
                        if(e.response){
                            console.log(e.response.data);
                        }else {
                            throw new Error('An error occurred connecting with the server.');
                        }
                    });
                }
            },
            play(){

    			// const rand = Math.floor(Math.random() * 10) + 1;
                //
    			// console.log(rand);
                //
    			// if(rand > 5){
                //     if(this.hls){
                //         this.hls.destroy();
                //     }
                //     this.hls = new Hls();
                //     this.hls.loadSource('sdfsdfs');
                //     this.hls.attachMedia(this.player.media);
                // }
                //
    			// console.log('is playing: ' + this.is_playing);

                this.player.play().then(()=>{

                	if(!this.start_time)
                    {
                        this.start_time = Math.round(Date.now() / 1000);
                    }

                }).catch((error)=>{
                    if(this.autoplay_error){

                        this.autoHlsErrorRecovery();

                        return;
                    }
                    // console.log('error playing next video');
                    console.log(error);
                    this.throwAutoPlayError();
                });

                this.monitorPlayback();
            },
            throwAutoPlayError(){
                if(!this.has_thrown_error)
                {
                  this.has_thrown_error = true;

                  if(this.autoplay_error){
                    // console.log('aborting throwing autoplay error since error is already showing');
                    this.autoHlsErrorRecovery();
                    return;
                  }
                  if(this.is_playing){
                    // console.log('aborting throwing autoplay error since video is playing');
                    return;
                  }
                  // console.log('throwing autoplay error.');
                  this.autoplay_error = true;
                  $('.video-player-overlay').hide();
                  $('.video-player-overlay.autoplay-error').css('display', 'flex');
                }else {
                    this.autoHlsErrorRecovery();
                }
            },
            monitorPlayback(iteration = 1)
            {
            	if(this.autoplay_error){
            		// console.log('not monitoring since autoplay error active');
            		return;
                }

            	// console.log('monitoring playback. Iteration: ' + iteration);

            	// console.log('is playing: ' + this.is_playing);

            	if(!this.is_playing && iteration > 24){
            		// console.log('iteration reached max count. Throwing autoplay error...');
                    this.throwAutoPlayError();
            		return false;
                }

                if(!this.is_playing){
                    setTimeout(()=>{
                        this.monitorPlayback(iteration + 1);
                    },250);
                }
            },
    		playPrevious()
            {
    		    if(this.current_drill_index === 0) return false;
    		    this.in_transition = true;
    		    this.is_playing = false;
    		    this.current_drill_index--;
    		    this.mountAndAttach();
    		    this.play();
            },
            playNext()
            {
    			if(this.current_drill_index === (this.sources.length - 1)) return false;
    			this.in_transition = true;
    			this.is_playing = false;
    		    this.current_drill_index++;
    		    this.mountAndAttach();
    		    this.play();
            },
            togglePlay(){
            	this.is_playing ? this.player.pause() : this.play();
            },
            recoverAndPlay(){
    			this.autoplay_error = false;
                this.mountAndAttach();
                this.play();
            },
            allowHeightAdjust(){
                const $el = $('.container.video-player');
                $el.css('height', 'auto');
                this.$nextTick(()=>{
                    this.fixHeight();
                })
            },
            fixHeight(){
                const $el = $('.container.video-player');
                const h = $el.outerHeight();
                $el.css('height', h + 'px');
            }
        }
    }

</script>
